// regex para validação de e-mail usada pela w3c
export default function validaEmail(val) {
  let emailRgx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  if (val.search(emailRgx) >= 0) return null
  return "E-mail inválido"
}
